<template>
  <dashboard-main-layout>
    <div class="fleet-page-wrapper">
      <!-- custom-selectors slot -->
      <appbar-bordered class="sticky-bar" :showBorder="true" :dense="true">
        <div
          class="d-flex align-content-start"
          style="gap: 24px; height: 100%; width: fit-content"
        >
          <!-- Site Selector -->
          <div class="fleet_selector">
            <v-menu
              v-model="menuSite"
              offset-y
              :close-on-content-click="false"
              style="width: 700px; max-height: 500px; overflow-y: auto"
            >
              <!-- Activator -->
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="displayFirst"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  :label="$t('_selectionner_des_sites_')"
                  @click.stop="menuSite = true"
                >
                  <template v-slot:append>
                    <span v-if="selectedIds.length > 1">
                      (+{{ selectedIds.length - 1 }})
                    </span>
                  </template>
                </v-text-field>
              </template>

              <!-- Dropdown -->
              <v-card
                style="
                  width: 700px;
                  min-height: 300px;
                  max-height: 500px;
                  overflow-y: auto;
                "
              >
                <v-row
                  justify="space-between"
                  align="center"
                  class="drop_down_text"
                >
                  <v-btn small text @click="selectAllTree">{{
                    this.$t("_select_all_")
                  }}</v-btn>
                  <v-btn small text @click="clearAllTree">{{
                    this.$t("_clear_all_")
                  }}</v-btn>
                </v-row>
                <v-text-field
                  v-model="treeSearch"
                  :placeholder="$t('_search_sites_')"
                  dense
                  outlined
                  hide-details
                  class="mt-2"
                />
                <v-treeview
                  :items="treeItems"
                  item-key="id"
                  v-model="selectedIds"
                  dense
                  activatable
                  hoverable
                  transition
                  :open-on-click="true"
                  :search="treeSearch"
                >
                  <template v-slot:label="{ item }">
                    <span>{{ getLabel(item.name) }}</span>
                  </template>
                  <template v-slot:prepend="{ item }">
                    <v-checkbox
                      v-if="item.children && item.children.length"
                      :input-value="isGroupSelected(item) === 'all'"
                      :indeterminate="isGroupSelected(item) === 'some'"
                      @click.stop="toggleGroup(item)"
                      dense
                      hide-details
                      color="primary"
                    ></v-checkbox>

                    <v-checkbox
                      v-else
                      v-model="selectedIds"
                      :value="item.id"
                      @click.stop
                      dense
                      hide-details
                      color="primary"
                    ></v-checkbox>
                  </template>
                </v-treeview>
              </v-card>
            </v-menu>
          </div>

          <!-- Loading -->
          <LoadingDialog v-if="loading" :is_loading="loading" />

          <!-- Date Picker -->
          <div
            v-if="
              $route.name === 'dashboard-fleet' &&
              !evolution_fleet &&
              (alarmes_fleet || alarmes_fleetandevolution_fleet)
            "
            class="date_selector"
          >
            <div class="d-flex align-center" style="gap: 10px">
              <div v-if="isWarningCondition" style="position: relative">
                <v-icon
                  @click="showAlert = !showAlert"
                  :color="color_warning_msg"
                >
                  mdi-alert
                </v-icon>
                <v-alert
                  v-model="showAlert"
                  type="info"
                  dense
                  shaped
                  dismissible
                  :color="color_warning_msg"
                  class="mt-2"
                  style="
                    position: absolute;
                    top: -15px;
                    left: 220px;
                    width: 400px;
                    z-index: 10;
                  "
                >
                  {{ warning_error_msg }}
                </v-alert>
              </div>

              <!-- Date selector -->
              <v-menu
                v-model="menuDate"
                content-class="custom-datepicker-menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-combobox
                    v-model="dateRange"
                    prepend-icon="mdi-calendar"
                    :color="isDateModified ? 'orange' : 'grey darken-1'"
                    readonly
                    hide-details
                    v-bind="attrs"
                    class="fleet-date"
                    v-on="on"
                    @click="menuDate = true"
                    @click:prepend="
                      isDateModified ? resetToMaxDate() : (menuDate = true)
                    "
                  />
                </template>

                <v-date-picker
                  v-model="tempDate"
                  scrollable
                  :min="'2016-01-01'"
                  :max="maxDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn text @click="menu = false">Annuler</v-btn>
                  <v-btn text color="primary" @click="refreshDates"
                    >Rafraichir</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
          </div>
        </div>
      </appbar-bordered>
      <div>
        <div style="display: flex">
          <dashboardfleet
            :liste_dashboard="list_dashboard"
            :alarmsByInstallation="alarmsByInstallation"
          />
          <v-card
            style="
              flex: 1;
              margin-top: 10px;
              margin-left: 5px;
              margin-right: 10px;
            "
          >
            <Mapfleet
              :key="JSON.stringify(list_fleet.data)"
              :selectsite="choosesitefleet"
              :liste_fleet="list_fleet.data || []"
            />
          </v-card>
        </div>
        <div>
          <v-card
            style="
              flex: 1;
              margin-top: 10px;
              margin-left: 10px;
              margin-right: 10px;
              border-top: 10px;
              border-bottom: 0px;
              padding: 10px;
            "
          >
            <div class="btn">
              <v-btn @click="setChangebuttonname(0)">{{
                $t("_evolutions_")
              }}</v-btn>
              <v-btn @click="setChangebuttonname(1)">{{
                $t("_evolutions_/_alarmes_")
              }}</v-btn>
              <v-btn
                @click="setChangebuttonname(2)"
                :color="changelable === '_exit_' ? 'orange' : undefined"
                >{{ $t(changelable) }}</v-btn
              >
            </div>
          </v-card>
          <div style="display: flex">
            <v-card
              v-if="
                evolution_fleet == true ||
                alarmes_fleetandevolution_fleet == true
              "
              :style="{
                marginRight: evolution_fleet == true ? '10px' : '0',
                marginLeft: '10px',
                backgroundColor: '#f5f5f5',
                border: '5px solid orange',
                borderRadius: '8px',
              }"
              style="flex: 1; margin-left: 10px; border-radius: 0"
            >
              <Evolutionfleet
                :selected_site_id="list_id"
                :change_size="alarmes_fleetandevolution_fleet"
              />
            </v-card>
            <v-card
              v-if="
                alarmes_fleet == true || alarmes_fleetandevolution_fleet == true
              "
              :style="{
                marginLeft: alarmes_fleet == true ? '10px' : '0',
                marginRight: '10px',
              }"
              style="flex: 1; margin-right: 10px; border-radius: 0"
            >
              <Alarmsfleet
                :liste_alarmes="list_alarms"
                :activeButton="this.activeButton"
                :selected_date="dateRange"
                :selected_site_id="list_id"
              />
            </v-card>
          </div>
        </div>
        <div>
          <v-card
            style="
              margin-bottom: 10px;
              margin-left: 10px;
              margin-right: 10px;
              margin-top: -20px;
            "
          >
            <Installationsfleet
              :selectsite="choosesitefleet"
              :liste_fleet="list_fleet.data"
              :selected_date="dateRange"
            />
          </v-card>
        </div>
      </div>
    </div>
  </dashboard-main-layout>
</template>

<script>
import DashboardMainLayout from "../../../layouts/Dashboard/MainLayout";
import AppbarBordered from "../../../components/Utils/AppbarBordered";
import { mapGetters } from "vuex";
import dashboardfleet from "./dashboardfleet.vue";
import Mapfleet from "./Mapfleet.vue";
import Installationsfleet from "./Installationsfleet";
import Alarmsfleet from "./Alarmsfleet";
import Evolutionfleet from "./Evolutionfleet";
import api from "@/api/api";
import LoadingDialog from "@/components/Utils/LoadingDialog";

export default {
  components: {
    DashboardMainLayout,
    AppbarBordered,
    dashboardfleet,
    Mapfleet,
    Installationsfleet,
    Alarmsfleet,
    Evolutionfleet,
    LoadingDialog,
  },

  mounted() {
    this.setDefaultDateToYesterday();

    this.setChangebuttonname(2);
    if (!this.isDataFetched) {
      this.loadInstallationData().then(() => {});
    }

    this.$nextTick(async () => {
      await this.loadInstallationData();

      if (!this.selectedIds || this.selectedIds.length === 0) {
        this.selectAllTree();
      }

      await this.take_selected_id();
    });

    this.isDateModified = this.dateRange !== this.maxDate;
  },

  data() {
    return {
      loading: false,
      menuSite: false, // for site selector
      menuDate: false,
      alarmes_fleet: false,
      evolution_fleet: false,
      total: 0,
      list_fleet: {
        data: [],
        total: {},
      },
      alarmes_fleetandevolution_fleet: true,
      activeButton: 0,
      menu: false,
      color_warning_msg: "",
      maxDate: new Date(Date.now() - 86400000).toISOString().substr(0, 10), // 86400000 ms = 1 day
      warning_error_msg: "",
      isDateModified: false,
      tempDate: null,
      showAlert: false,
      isManualClose: true,
      count: 0,
      list_names: [],
      changeprint: 1,

      nb_of_sites_sent: 0,
      list_id: [],
      compteur: 0,
      isDataFetched: false,
      defaultDashboard: {
        nb_de_site: 0,
        pr_clean_parc: 0,
        pr_clean_parc_evo: 0,
        ip_clean_parc: 0,
        ip_clean_parc_evo: 0,
        pc_totale: 0,
        disponibilite_parc: 0,
        disponibilite_parc_evo: "_ ",
        pertes_recouvrables: "_ ",
        pertes_vs_modele_energie: "_ ",
        pertes_vs_modele_energie_evo: "_ ",
        major_alarms: 0,
        minor_alarms: 0,
        without_alarms: 0,
      },
      list_dashboard: {
        nb_de_site: 0,
        pr_clean_parc: 0,
        pr_clean_parc_evo: 0,
        ip_clean_parc: 0,
        ip_clean_parc_evo: 0,
        pc_totale: 0,
        disponibilite_parc: 0,
        disponibilite_parc_evo: "_ ",
        pertes_recouvrables: "_ ",
        pertes_vs_modele_energie: "_ ",
        pertes_vs_modele_energie_evo: "_ ",
        major_alarms: 0,
        minor_alarms: 0,
        without_alarms: 0,
      },
      list_alarms: [],
      alarmsByInstallation: {
        major_alarms: 0,
        minor_alarms: 0,
        no_alarm_found: 0,
      },
      defaultalarmsByInstallation: {
        major_alarms: 0,
        minor_alarms: 0,
        no_alarm_found: 0,
      },

      treeSearch: "",
      filteredGroups: [],
    };
  },

  computed: {
    itemsWithSelectAllfleet() {
      return this.list_names;
    },
    ...mapGetters({
      cur_install_id: "cur_install_id",
      installations: "installations",
      role: "role",
    }),

    parcDates() {
      return this.$store.state.parametersStore.dates;
    },

    dateRange: {
      get() {
        // Always return the string from Vuex, not the object
        return this.$store.getters.parcDates.start || "";
      },
      set(value) {
        // Update Vuex properly when date changes
        this.$store.commit("SET_PARC_DATES_START", value);
      },
    },

    icon() {
      if (this.choosesAllfleet) return "mdi-close-box";
      if (this.choosesSomefleet) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    changelable() {
      if (!this.evolution_fleet && !this.alarmes_fleetandevolution_fleet) {
        return "_alarmes_";
      } else if (
        !this.evolution_fleet ||
        !this.alarmes_fleetandevolution_fleet
      ) {
        return "_exit_";
      }
      return "_alarmes_";
    },
    isWarningCondition() {
      const result = Math.abs(
        this.nb_of_sites_sent - this.list_dashboard.nb_de_site
      );
      return result != 0 && this.dateRange === this.maxDate;
    },

    choosesitefleet() {
      return this.installations
        .filter((inst) => this.selectedIds.includes(inst.installation_id))
        .map((inst) => inst.installation_name);
    },
    selectedIds: {
      get() {
        return (
          this.$store.getters[
            "treeSelectedSitesStore/treeSelectedSitesFleet"
          ] || []
        );
      },
      set(val) {
        this.$store.commit(
          "treeSelectedSitesStore/SET_TREE_SELECTED_SITES_FLEET",
          val
        );
      },
    },
    displayFirst() {
      if (!this.selectedIds.length) return "";

      const first = this.installations.find(
        (i) => i.installation_id === this.selectedIds[0]
      );

      return first ? first.installation_name : "";
    },
    treeItems() {
      return this.filteredGroups || [];
    },
    treeItemsFlat() {
      const flatten = (items) =>
        items.reduce(
          (acc, item) => [
            ...acc,
            { id: item.id, name: item.name },
            ...(item.children ? flatten(item.children) : []),
          ],
          []
        );
      return flatten(this.treeItems);
    },

    filteredTreeItems() {
      if (!this.treeSearch) return this.treeItems;
      const search = this.treeSearch.toLowerCase();

      // Simple flat filter, adjust if you need nested tree filtering
      const filterTree = (items) =>
        items
          .map((item) => {
            const children = item.children ? filterTree(item.children) : [];
            if (item.name.toLowerCase().includes(search) || children.length) {
              return { ...item, children };
            }
            return null;
          })
          .filter(Boolean);

      return filterTree(this.treeItems);
    },
  },

  watch: {
    selectedIds(newVal) {
      localStorage.setItem("selectedIds", JSON.stringify(newVal));
      this.total = newVal.length - 1;
      this.take_selected_id();
    },
    dateRange(newVal) {
      this.isDateModified = newVal !== this.maxDate;
      this.take_selected_id();
    },

    "$root.$i18n.locale": {
      async handler() {
        await this.take_selected_id();
        this.changelable;
      },
      immediate: true,
      deep: true,
    },
    $route: {
      async handler() {
        //this.refresHeader()
        await this.$nextTick();
        this.isDataFetched = false;
        await this.take_selected_id();
      },
      immediate: true,
    },

    async "$store.getters.parcCalendarRefresh"() {
      if (this.$store.getters.parcCalendarRefresh) {
        this.$store.commit("SET_PARC_CALENDAR_REFRESH", false);
        this.dateRange = this.$store.getters.parcDates.start;
      }
    },
  },

  methods: {
    setDefaultDateToYesterday() {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      if (this.$store.getters.parcDates.start)
        this.dateRange = this.$store.getters.parcDates.start;
      else this.dateRange = yesterday.toISOString().slice(0, 10);
    },

    resetToMaxDate() {
      this.dateRange = this.maxDate;
      this.tempDate = this.maxDate;
      this.isDateModified = false;
      this.take_selected_id();
    },

    // takeitems only called once and data is cached
    async takeitems() {
      let liste_2 = this.installations.map((e) => e.installation_id.toString());

      if (!liste_2.length) return [];

      const current_role = ["admin", "data-analyst"];
      const hasPrivilegedRole = current_role.includes(this.role);

      try {
        const response = await api.getFleetInstallationList(liste_2);

        // 🔥 BUILD GROUPS
        const groups = response.data.map((group) => {
          const filteredChildren = group.children
            .map((child) => {
              const site = this.installations.find(
                (s) => child.name.trim() === s.installation_name.trim()
              );

              if (!site) return null;

              if (!hasPrivilegedRole && !child.is_visible) return null;

              // ✅ Keep IDs for treeview
              return {
                id: site.installation_id,
                name: site.installation_name.trim(),
              };
            })
            .filter(Boolean);

          return {
            id: group.id,
            name: group.name,
            children: filteredChildren,
          };
        });

        this.filteredGroups = groups;

        return groups;
      } catch (error) {
        console.error("Error fetching fleet info:", error);
        return [];
      }
    },

    async loadInstallationData() {
      if (this.isDataFetched) return;

      // 1. Fetch the group/tree structure
      await this.takeitems();

      // 2. If nothing is selected (first visit), select everything
      if (!this.selectedIds || this.selectedIds.length === 0) {
        this.selectAllTree();
      }

      this.isDataFetched = true;
      this.total = this.selectedIds.length - 1;
    },

    async take_selected_id() {
      let site_names_sent = "";
      this.nb_of_sites_sent = 0;
      this.list_id = [];
      this.list_fleet = { data: [], total: {} };
      this.list_dashboard = { ...this.defaultDashboard };
      this.alarmsByInstallation = { ...this.defaultalarmsByInstallation };

      this.list_alarms = [];
      const elm = [
        ...new Set(
          this.selectedIds.filter((id) => !String(id).startsWith("group"))
        ),
      ];
      if (elm.length === 0) {
        this.loading = false;
        return;
      }
      this.list_id = elm;
      this.nb_of_sites_sent = elm.length;
      try {
        const results = await Promise.allSettled([
          api.getlistfleet({
            fleet: elm,
            dates: this.dateRange,
            country_lang_code: this.$root.$i18n.locale,
          }),
          api.getlistalarms({
            alarms: elm,
            dates: this.dateRange,
            country_lang_code: this.$root.$i18n.locale,
          }),
        ]);

        // --- Handle Fleet Result ---
        if (results[0].status === "fulfilled") {
          const response = results[0].value.data;
          this.list_fleet = Array.isArray(response)
            ? { data: response, total: {} }
            : response;
          this.list_dashboard = response.total
            ? { ...response.total }
            : { ...this.defaultDashboard };
        } else {
          console.error("Fleet API failed:", results[0].reason);
          this.list_fleet = { data: [], total: {} };
          this.list_dashboard = { ...this.defaultDashboard };
        }

        // --- Handle Alarms Result ---
        if (results[1].status === "fulfilled") {
          this.list_alarms = results[1].value.data || [];
          this.calculateAlarmStats(this.list_alarms);
        } else {
          console.error("Alarms API failed:", results[1].reason);
          this.list_alarms = [];
          this.alarmsByInstallation = { ...this.defaultalarmsByInstallation };
        }

        //  this.calculateAlarmStats(this.list_alarms);
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        this.loading = false;
      }

      const fleetData = Array.isArray(this.list_fleet?.data)
        ? this.list_fleet.data
        : [];
      const receivedIds = fleetData.map((i) => i.installation_id);
      const missingIds = elm.filter(
        (id) => !receivedIds.includes(parseInt(id, 10))
      );

      const missingNames = missingIds
        .map((id) => {
          const s = this.installations.find(
            (inst) => inst.installation_id === id
          );
          return s ? s.installation_name.trim() : null;
        })
        .filter(Boolean);

      site_names_sent = missingNames.join(",\n");
      // Get current hour now
      const currentHour = new Date().getHours();
      if (this.dateRange === this.maxDate && missingNames.length != 0) {
        if (currentHour >= 0 && currentHour <= 7) {
          // case when installations > 5 → show difference in numbers
          this.color_warning_msg = "orange";
          this.warning_error_msg = `Données en cours d’acquisition`;
          this.showAlert = true;
        } else if (currentHour >= 8) {
          if (missingNames.length > 5) {
            this.color_warning_msg = "#ff0000";
            this.warning_error_msg = `Données manquantes pour ${missingNames.length} sites `;
            this.showAlert = true;
          } else {
            this.color_warning_msg = "#ff0000";
            this.warning_error_msg = `Données manquantes pour ${site_names_sent} `;
            this.showAlert = true;
          }
        }
      }
      this.compteur++;
    },
    calculateAlarmStats(list_alarms) {
      // 🔥 Build a fresh object (NOT reactive yet)
      let stats = {
        major_alarms: 0,
        minor_alarms: 0,
        no_alarm_found: 0,
      };

      const alarmsBySite = list_alarms.reduce((acc, alarm) => {
        if (!acc[alarm.installation_id]) acc[alarm.installation_id] = [];
        acc[alarm.installation_id].push(alarm);
        return acc;
      }, {});

      const installationResults = {};

      Object.keys(alarmsBySite).forEach((siteId) => {
        const siteAlarms = alarmsBySite[siteId];

        const hasCritique = siteAlarms.some(
          (a) => a.criticity_info === "_critique_"
        );
        const hasSevere = siteAlarms.some(
          (a) => a.criticity_info === "_severe_"
        );

        installationResults[siteId] = {
          critique: hasCritique ? 1 : 0,
          severe: hasSevere ? 1 : 0,
        };

        if (hasCritique) stats.major_alarms++;
        else if (hasSevere) stats.minor_alarms++;
        else stats.no_alarm_found++;
      });

      // Handle sites with NO alarms at all
      if (this.list_fleet.data) {
        this.list_fleet.data.forEach((fleetItem) => {
          const siteId = fleetItem.installation_id;

          if (!installationResults.hasOwnProperty(siteId)) {
            stats.no_alarm_found++;
          }
        });
      }

      // ✅ FINAL assignment (this triggers Vue properly)
      this.alarmsByInstallation = { ...stats };
    },

    setChangebuttonname(value) {
      this.activeButton = value; // Update the active button state
      if (value === 0) {
        this.alarmes_fleet = false;
        this.evolution_fleet = true;
        this.alarmes_fleetandevolution_fleet = false;
      } else if (value === 1) {
        this.evolution_fleet = false;
        this.alarmes_fleetandevolution_fleet = true;
        this.alarmes_fleet = false;
      } else if (value === 2) {
        this.alarmes_fleet = true;
        this.evolution_fleet = false;
        this.alarmes_fleetandevolution_fleet = false;
      }
    },

    refreshDates() {
      if (this.tempDate) {
        // If tempDate is already a string in YYYY-MM-DD format
        this.dateRange = this.tempDate;
      }
      this.menuDate = false;
    },

    selectAllTree() {
      // Use the raw ID type (usually Number) instead of .toString()
      // unless your API strictly returns strings for IDs.
      this.selectedIds = this.filteredGroups.flatMap((g) =>
        g.children.map((c) => c.id)
      );
    },

    toggleGroup(group) {
      const childIds = group.children.map((c) => c.id); // Match the type in treeItems
      const selectedSet = new Set(this.selectedIds);
      const allSelected = childIds.every((id) => selectedSet.has(id));

      if (allSelected) {
        this.selectedIds = this.selectedIds.filter(
          (id) => !childIds.includes(id)
        );
      } else {
        this.selectedIds = [...new Set([...this.selectedIds, ...childIds])];
      }
    },
    async clearAllTree() {
      this.selectedIds = [];
      this.activeIds = [];
      await this.take_selected_id();
    },
    isGroupSelected(group) {
      if (!group.children || !group.children.length) return false;
      const childIds = group.children.map((c) => c.id.toString());
      const selectedSet = new Set(this.selectedIds);
      const selectedCount = childIds.filter((id) => selectedSet.has(id)).length;

      if (selectedCount === 0) return "none"; // no children selected
      if (selectedCount === childIds.length) return "all"; // all children selected
      return "some"; // partially selected
    },
    getLabel(name) {
      if (name === "_no_group_") return this.$t("_no_group_");
      return name;
    },
  },
};
</script>

<style scoped>
/* --- LAYOUT & MARGINS (Keep these as they are) --- */
.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;
}

.date_selector {
  width: 200px;
  margin-top: 5px;
  margin-left: 50px;
  margin-right: 0px;
}

::v-deep .v-main {
  padding-top: 64px !important;
  padding-left: 256px !important;
  background-color: #f5f5f5 !important;
}

.fleet-date .v-input__slot {
  min-height: 40px !important; /* Force standard Vuetify height */
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 12px !important;
}

/* Remove the extra space usually reserved for hints/errors */
::v-deep .fleet-date .v-text-field__details {
  display: none !important;
  margin: 0 !important;
  padding: 0 !important;
  min-height: 0 !important;
}

/* --- TABLE STYLING (Wrapped in deep to work with scoped) --- */
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr {
  background-color: rgb(214, 214, 214);
  border-radius: 5px;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  color: #504f4f;
  padding-top: 10px;
  padding-bottom: 10px;
}

::v-deep .v-picker--date {
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.2) !important;
}

/* Tablet */
@media (max-width: 992px) {
  .fleet-date {
    width: 200px !important;
  }
}

/* Mobile */
@media (max-width: 600px) {
  .fleet-date {
    width: 100% !important;
    min-width: 0 !important;
  }
}
/* ::v-deep  .v-toolbar__content{
  height: 48px !important;
  padding-top: 0 !important;
  padding-bottom: 0!important;
} */
.fleet_selector {
  margin-left: 20px;
  margin-top: 5px;
  width: 700px;
}
::v-deep .v-input__control {
  height: 48px !important;
}
.drop_down_text {
  margin-top: 0px;
}
.sticky-bar {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: white;
}
.v-treeview-node__prepend .v-input--selection-controls {
  margin-top: 15px; /* tweak: try 1px–4px depending on your UI */
}
.fleet-page .v-menu__content {
  z-index: 110 !important;
}
</style>
<style>
/* Target the ID directly to increase priority
#content.v-main {
  padding-top: 64px !important;
} */

.fleet-tree_view {
  min-width: 700px !important;
  max-width: 700px !important;
  max-height: 500px !important;
}

/* Date picker dropdown */
.custom-datepicker-menu {
  min-width: 290px !important;
  max-width: 290px !important;
}

</style>
